import { useState, useEffect, useMemo } from 'react';

export const useOnScreen = (ref) => {
    const [isIntersecting, setIntersecting] = useState(false);

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref]);

    useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }
        // Remove o observer quando o componente é desmontado
        return () => {
            if (ref.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                observer.unobserve(ref.current);
            }
        };
    }, []); // Roda apenas uma vez

    return isIntersecting;
};